module.exports = __webpack_public_path__ + "img/Matrix-Header-Logo.68aa3137.png";